import { render } from "./CajPerkhidmatanShow.vue?vue&type=template&id=2827b8f5"
import script from "./CajPerkhidmatanShow.vue?vue&type=script&lang=js"
export * from "./CajPerkhidmatanShow.vue?vue&type=script&lang=js"

import "./CajPerkhidmatanShow.vue?vue&type=style&index=0&id=2827b8f5&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__